import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { PromptuaryQualityWarning } from './promptuary-quality-warning.component';

@NgModule({
	declarations: [PromptuaryQualityWarning],
	imports: [CommonModule, TranslateModule.forChild()],
	exports: [PromptuaryQualityWarning],
	providers: [],
})
export class PromptuaryQualityWarningModule {}
